/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Page from "components/common_components/Page/Page";
import { PDFDocument } from "pdf-lib";
import { Document, Page as Page2 } from "react-pdf";

import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";
import FormField from "./components/FormField";
import i485Pdf from "./i-485.pdf";

// Ref: https://pdf-lib.js.org/#fill-form
const FillForm = () => {
    // const [file, setFile] = useState();
    const [fields, setFields] = useState({});
    const [pdfUrl, setPdfUrl] = useState();
    const [numPages, setNumPages] = useState(null);
    const [values, setValues] = useState({});

    const getFieldValue = (fieldName) => {
        return values[fieldName] || "";
    };

    const setFieldValue = (fieldName, value) => {
        setValues((prev) => ({ ...prev, [fieldName]: value }));
    };

    const onDocumentLoadSuccess = ({ numPages }) => {
        setNumPages(numPages);
        // Aquí podrías usar pdf-lib para leer los campos iniciales
        // y pre-poblar el estado `formData` si es necesario.
    };

    useEffect(() => {
        setPdfUrl(i485Pdf);
    }, []);

    useEffect(() => {
        if (pdfUrl) {
            prepareFields();
        }
    }, [pdfUrl]);

    async function prepareFields() {
        // 1. Cargar el documento PDF
        const existingPdfBytes = await fetch(pdfUrl).then((res) => res.arrayBuffer());
        const pdfDoc = await PDFDocument.load(existingPdfBytes, { ignoreEncryption: true });
        const form = pdfDoc.getForm();

        // Objeto para almacenar los resultados

        // 2. Obtener todas las páginas del documento para poder saber su altura
        const pages = pdfDoc.getPages();
        const fieldData = pages.reduce((map, _, idx) => {
            map[idx] = [];
            return map;
        }, {});
        // 3. Iterar sobre cada campo del formulario
        const fields = form.getFields();
        fields
            .filter((f) => !f.isReadOnly())
            .forEach((field) => {
                const { pageIndex, component } = FormField({
                    pages,
                    field,
                });
                fieldData[pageIndex].push(component);
            });

        setFields(fieldData);
    }

    console.log("values", values);

    return (
        <Page>
            {/* <input type="file" onChange={handleOnChange} /> */}

            <div style={{ border: "1px solid black" }}>
                <Document file={pdfUrl} onLoadSuccess={onDocumentLoadSuccess}>
                    {Array.from(new Array(numPages), (el, index) => (
                        <Page2 key={`page_${index + 1}`} pageNumber={index + 1} width={1024}>
                            {fields[String(index)]?.map((component) => {
                                const Component = component;
                                return <Component valueGetter={(fieldName) => getFieldValue(fieldName)} onChange={setFieldValue} />;
                            })}
                        </Page2>
                    ))}
                </Document>
            </div>
        </Page>
    );
};

export default FillForm;
